import { render } from "./RolloHistoriaMapa.vue?vue&type=template&id=600c8247"
import script from "./RolloHistoriaMapa.vue?vue&type=script&lang=js"
export * from "./RolloHistoriaMapa.vue?vue&type=script&lang=js"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__